import api from "./axios";

export const createCampaignApi = (data) => api.post("/campaigns", data);

export const getCampaignsApi = (params = {}) =>
  api.get("/campaigns", { params });

export const getCampaignApi = (id) => api.get(`/campaigns/${id}`);

export const updateCampaignApi = (id, data) =>
  api.put(`/campaigns/${id}`, data);

export const deleteCampaignApi = (id) => api.delete(`/campaigns/${id}`);

export const sendCampaignApi = (id) => api.post(`/campaigns/${id}/send`);

export const validateContactsApi = (data) =>
  api.post("/campaigns/validate", data, { skipToast: true });
